import { useEffect, useState } from "react";

export function useCurrentRoute() {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    useEffect(() => {
        // Detect initial route
        setCurrentPath(window.location.pathname);

        // Detect browser navigation (back/forward)
        const handlePopState = () => {
            setCurrentPath(window.location.pathname);
        };

        // Detect programmatic navigation via history.pushState/replaceState
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;

        window.history.pushState = (...args) => {
            originalPushState.apply(window.history, args);
            setCurrentPath(window.location.pathname);
        };

        window.history.replaceState = (...args) => {
            originalReplaceState.apply(window.history, args);
            setCurrentPath(window.location.pathname);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, []);

    return currentPath;
}
